var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"Header-Wrapper"},[_c('simple-header',{attrs:{"label":_vm.$t('tasting.previous')},on:{"click":_vm.goBack}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }